import React from "react";
import PropTypes from "prop-types";
import ActionButton from "./ActionButton";
import { getPrimaryActions } from "./NonRKPayInvoiceActionsConfig";
import ActionsList from "./ActionsList";

const ToolbarActions = ({
	nonRKPayInvoiceDetailHook,
	isSuperAdmin,
	toggleInvoiceStatusHistoryModal,
	toggleDisputeHistoryModal,
	isTimeCardNotesModalEnabled,
	clientV4InvoicingDisputes,
	areThereDisputesInHistory,
}) => {
	const primaryActions = getPrimaryActions({
		nonRKPayInvoiceDetailHook,
		toggleInvoiceStatusHistoryModal,
		toggleDisputeHistoryModal,
		isTimeCardNotesModalEnabled,
		isSuperAdmin,
		clientV4InvoicingDisputes,
		areThereDisputesInHistory,
	});

	return (
		<ActionsList
			actions={primaryActions}
			ButtonComponent={ActionButton}
		/>
	);
};

ToolbarActions.propTypes = {
	nonRKPayInvoiceDetailHook: PropTypes.object.isRequired,
	isSuperAdmin: PropTypes.bool.isRequired,
	toggleInvoiceStatusHistoryModal: PropTypes.func.isRequired,
	toggleDisputeHistoryModal: PropTypes.func.isRequired,
	isTimeCardNotesModalEnabled: PropTypes.bool.isRequired,
	clientV4InvoicingDisputes: PropTypes.bool.isRequired,
	areThereDisputesInHistory: PropTypes.bool.isRequired,
};

export default ToolbarActions;
